import { cn } from '@/lib/utils'
import { Button, CardLink, Container, Section, Title } from '@/ui/components'
import { getTitleTag } from '@/utils'
import { memo } from 'react'
import { SectionLinkProps } from './type'

const SectionCardGrid = ({
  section,
  items,
  buttons,
  title,
  titleLayout,
  variant = 'link'
}: SectionLinkProps) => {
  if (!items || items?.length === 0) {
    return null
  }
  const cardVariant = variant === 'shop' ? 'shop' : 'content'

  return (
    <Section
      data={section}
      className={cn('s-section-link', {
        'bg-shop-100 text-shop-400': variant === 'shop'
      })}
    >
      <Container>
        <div className={''}>
          {title && titleLayout !== '100' && (
            <div className={'align-end mb-xl flex justify-between'}>
              <Title as={getTitleTag(titleLayout)} className="h2">
                {title}
              </Title>
              {buttons?.length && (
                <div className="gap-xs flex">
                  {buttons?.map((button, i) => (
                    <Button
                      key={i?.toString()}
                      {...button}
                      size="m"
                      variant="tertiary"
                    />
                  ))}
                </div>
              )}
            </div>
          )}
          <div className="gap-xs grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
            {items?.map((item, i) => (
              <div key={i?.toString()} className={cn('')}>
                <CardLink
                  {...item}
                  variant={cardVariant}
                  showArrow={variant === 'shop'}
                />
              </div>
            ))}
          </div>
        </div>
      </Container>
    </Section>
  )
}

SectionCardGrid.displayName = 'SectionCardGrid'

export default memo(SectionCardGrid)
